module.exports = __webpack_public_path__ + "6ce1573ef06ce0d0902df783c77ebcde.svg";